import { cn } from "@tellescope/ui";

export const RICH_TEXT_CONTENT_CLASS = cn(
  "min-h-full outline-none",
  "[&_ul]:list-disc [&_ul]:ml-6 [&_ul]:my-2",
  "[&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:my-2",
  "[&_li]:my-1",
  "[&_h1]:text-2xl [&_h1]:font-bold [&_h1]:my-3",
  "[&_h2]:text-xl [&_h2]:font-bold [&_h2]:my-3",
  "[&_h3]:text-lg [&_h3]:font-semibold [&_h3]:my-2",
  "[&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:my-2",
  "[&_code]:rounded [&_code]:bg-gray-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-sm",
  "[&_pre]:rounded [&_pre]:bg-gray-100 [&_pre]:p-3 [&_pre]:font-mono [&_pre]:text-sm [&_pre]:my-2 [&_pre]:overflow-x-auto",
  "[&_pre_code]:bg-transparent [&_pre_code]:p-0",
  "[&_hr]:my-3 [&_hr]:border-t [&_hr]:border-gray-300",
  "[&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
  "[&>ul:first-child>li:first-child]:mt-0 [&>ol:first-child>li:first-child]:mt-0",
  "[&>ul:last-child>li:last-child]:mb-0 [&>ol:last-child>li:last-child]:mb-0"
);
